import gql from 'graphql-tag'

export const upsertOrder = gql`
  mutation upsertOrder(
    $id: ID
    $date: OrderDate!
    $products: UpdateProductRelation!
  ) {
    upsertOrder(
      id: $id,
      orderDate: $date,
      products: $products
    ) {
      id
      date
      submitted
      editable
      products {
        id
        name
        slug
        unit
        item_number
        pivot {
          quantity
        }
      }
    }
  }
`

export const submitOrder = gql`
  mutation submitOrder($id: ID) {
    submitOrder(id: $id) {
      id
      date
      submitted
      submitted_at
      editable
    }
  }
`

export const submitChangelog = gql`
  mutation submitChangelog($id: ID!, $date: OrderDate!, $products: UpdateProductRelation!) {
    submitChangelog(id: $id, orderDate: $date, products: $products) {
      id
      date
      submitted
      submitted_at
      editable
    }
  }
`

export const deleteOrder = gql`
  mutation deleteOrder($id: ID!, $submitted: Boolean!) {
    deleteOrder(id: $id, submitted: $submitted) {
      id
      success
    }
  }
`
